import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import escape from "escape-html";

import { IConfirmationButton, IConfirmationDialog } from "../domain/types";

@Component({
    selector: "app-confirmation-dialog",
    templateUrl: "./confirmation-dialog.component.html",
    styleUrls: ["./confirmation-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  shown = false;

  confirmation: IConfirmationDialog = {
    title: "",
    message: "",
    buttons: [{ styleClass: "", text: "Close", returnValue: "close" }],
  };

  constructor() {}

  ngOnInit(): void {
    this.shown = true;
  }

  handleButtonClick(button) {
    this.shown = false;
  }

  sanitize(content) {
    return escape(content);
  }
}
